import { LoadingOverlay } from 'foundations-components/transitional/components/LoadingOverlay';
import { Loadable } from 'foundations-components/transitional/utils/Loadable';
import { jsx as _jsx } from "react/jsx-runtime";
const MarketingHomePopup = Loadable({
  loader: () => import( /* webpackChunkName: "marketing-home-popup" */'FormsUI/components/marketingHome/components/MarketingHomePopup'),
  LoadingComponent: ({
    pastDelay
  }) => {
    return pastDelay ? /*#__PURE__*/_jsx(LoadingOverlay, {
      contextual: true
    }) : null;
  }
});
export default MarketingHomePopup;